import JSDB from '../fromKotlin/nk';

/** Cofc templates store line breaks as literal `\n`; normalize to real newlines. */
export function normalizeWhatsappLineBreaks(text: string): string {
    return text.replace(/\\n/g, '\n').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
}

/**
 * Prepare message for `api.whatsapp.com/send?text=…`.
 * Only newlines and `&` are encoded here — Hebrew/emojis stay as Unicode so the
 * browser encodes them once on open (full encodeURIComponent double-encodes emojis).
 */
export function encodeWhatsappShareText(text: string): string {
    return normalizeWhatsappLineBreaks(text)
        .replace(/\n/g, '%0A')
        .replace(/&/g, '%26');
}

/** True when cofc_conf.link_version==1 (company switched to the v2 ordering app). */
export function isOrderAppV2(): boolean {
    return Number(JSDB().userCofcConf?.link_version ?? 0) === 1;
}

/** Public ordering-app host sent to customers. `nihulkav.shop` still serves the same site. */
export const ORDER_SHOP_HOST = 'https://nihulkav.shop';

/** Public ordering-app base — `/v2/` when link_version is on. */
export function cofcOrderShopBase(): string {
    return isOrderAppV2() ? `${ORDER_SHOP_HOST}/v2/` : `${ORDER_SHOP_HOST}/`;
}

/** Self-order URL: `https://nihulkav.shop[/v2/]?pass=…&date=…[&returns=…]`. */
export function buildCofcOrderShopLink(
    pass: string,
    date: string,
    options?: { returns?: boolean },
): string {
    const returnsQuery =
        options?.returns === undefined ? '' : `&returns=${options.returns ? 'true' : 'false'}`;
    return `${cofcOrderShopBase()}?pass=${pass}&date=${date}${returnsQuery}`;
}

export function appendCofcOrderShopLink(
    messageText: string,
    pass: string,
    date: string,
    options?: { returns?: boolean },
): string {
    return `${normalizeWhatsappLineBreaks(messageText)}\n\n ${buildCofcOrderShopLink(pass, date, options)} \n`;
}
